module.exports = __webpack_public_path__ + "img/Desk Stationary A08.f44ac63d.jpg";